import { APP_ENV } from "./env.mjs";
const API_URL_PUBLIC = APP_ENV.TZA_BACKEND_API_URI_PUBLIC;
const API_URL = (() => {
  const configUri = new URL(APP_ENV.TZA_BACKEND_API_URI || "");
  if (import.meta.env.DEV) {
    if (window.location.hostname !== configUri.hostname) {
      configUri.hostname = window.location.hostname;
    }
  }
  return configUri.href;
})();
export { API_URL, API_URL_PUBLIC };
//# sourceMappingURL=api.mjs.map
